import React from 'react'
import './styles.css'

const TextHelperText = () => (
  <div className="textHelperText">
    <p>
      The initial request text will prompt a patient for a post-appointment
      survey. Replies that start with 'Yes' will be recorded as positive survey,
      while 'No' will be a negative survey.
    </p>
    {!process.env.REACT_APP_IS_TOPS && (
      <p>
        If there is more to their reply than 'Yes'/'No', it will be recorded as
        a comment viewable from the patient's page or the Reviews tab of the
        Dashboard.
      </p>
    )}
    <p>
      If you'd like to request a survey via text message, please add the social
      links to the text message setting.
    </p>
    <ul>
      <li>
        <span>@location_facebook_url</span>
      </li>
      <li>
        <span>@location_google_url</span>
      </li>
      <li>
        <span>@location_yelp_url</span>
      </li>
    </ul>
  </div>
)

export default TextHelperText



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/TextHelperText.js